<template>
  <div>
    <v-dialog v-model="show" persistent max-width="600px" width="100%">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>اضافة عقد</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 10px"></div>
          <v-row>
            <v-col cols="12">
              <v-text-field rounded outlined type="number" v-model="contractAmount" label="مبلغ العقد"></v-text-field>

              <v-autocomplete rounded v-model="currencyId" :items="currencies" item-text="currencyName" item-value="idCurrency" outlined label="العملة"></v-autocomplete>

              <v-autocomplete rounded v-model="resourceId" :items="resources" item-text="resourceName" item-value="idGenerationResource" outlined label="مصدر الايراد"></v-autocomplete>

              <v-dialog ref="dialogDate" v-model="showDate" :return-value.sync="contractDate" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field outlined rounded v-model="contractDate" label="تاريخ العقد" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="contractDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="$refs.dialogDate.save(contractDate)"> موافق </v-btn>
                  <v-btn text color="primary" @click="showDate = false"> الغاء </v-btn>
                </v-date-picker>
              </v-dialog>

              <v-textarea rounded rows="3" row-height="15" outlined v-model="contractNote" name="input-7-4" label="الملاحظات"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="saveData"> حفظ </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" fab small outlined color="primary" @click="show = true" v-bind="attrs" v-on="on">
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </template>
      <span>اضافة عقد</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    currencies: Array,
    resources: Array,
  },
  data: () => ({
    show: false,
    overlay: false,

    showDate: false,
    contractDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    contractAmount: "",
    contractNote: "",
    currencyId: "",
    resourceId: "",
  }),
  methods: {
    saveData() {
      let self = this;

      let data2 = {
        contractDate: self.contractDate,
        contractAmount: self.contractAmount,
        contractNote: self.contractNote,
        currencyId: self.currencyId,
        generationResourceId: self.resourceId,
        isValid: 1,
        createdBy: self.$store.state.userData.idUser,
      };

      console.log(data2);

      if (self.contractAmount && self.currencyId && self.resourceId) {
        let data = {
          contractDate: self.contractDate,
          contractAmount: self.contractAmount,
          contractNote: self.contractNote,
          currencyId: self.currencyId,
          generationResourceId: self.resourceId,
          isValid: 1,
          createdBy: self.$store.state.userData.idUser,
        };

        self.$http
          .post(`${self.$store.state.apiUrl}/addGenerationContract`, data, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            console.log(self.productImage);
            console.log(res.data);

            this.$toasted.success("تم اضافه البيانات");
            this.$emit("reloadTask");
          });
      } else {
        this.$toasted.error("الرجاء ملئ كافة الحقول");
      }

      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
